import axios from "axios";
import EnvManager from '../../config/envManager';

const backend = axios.create({
  baseURL: `${EnvManager.BACKEND_URL}/api`,
  withCredentials: true
});

export const getCategories = async () => {
  try {
    const response = await backend.get('/category');
    return response.data;
  }
  catch (error) {
    return null;
  }
};

export const postCategories = async () => {
  try {
    const response = await backend.post('/category');
    return response.data;
  } catch (error) {
    return null;
  }
};
